import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import * as ReactPdf from 'react-pdf';
import { pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import ReactToPrint from 'react-to-print';
import {
	Button,
	Link,
	makeStyles,
} from '@material-ui/core';
import ModalCustom from 'components/ModalCustom';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const useStyles = makeStyles(theme => ({
	documentPdf: {
		overflow: 'auto',
		flexGrow: 1,
		padding: theme.spacing(3),
		textAlign: '-webkit-center',
	},
	pdfButton: {
		'& > *': {
			margin: theme.spacing(1),
		},
		'text-align': 'right',
	},
	printTextColor: {
		color: theme.palette.white,
	},
}));

const PdfViewer = ({ 
    downloadFileName,
    isOpenPdfViewer, 
    onClose, 
    pdfFile, 
    title,
 }) => {
	const classes = useStyles();
	const reactPdfComp = useRef(null);
	const [ numPages, setNumPages ] = useState(null);

	const onDocumentLoadSuccess = ({ numPages }) => {
		setNumPages(numPages);
	};

	const renderAllPages = () => {
		const allPages = [];
		for (let i = 1; i <= numPages; i++) {
			allPages.push(<ReactPdf.Page pageNumber={i} key={'Page_' + i} />);
		}

		return allPages;
	};

	return (
		<ModalCustom
			title={title}
			open={isOpenPdfViewer}
			close={onClose}
			actions={false}
			backDrop={true}
			width="md"
		>
			<div className={classes.pdfButton}>
				<Button
					href={pdfFile}
					target="_blank"
					download={downloadFileName || "proposed_file_name"}
					component={Link}
					variant="contained"
					color="primary"
				>
                    Download
				</Button>
				<Button variant="contained" color="primary">
					<ReactToPrint
						trigger={() => {
							return (
								<Link className={classes.printTextColor} href="#">
                                    Print
								</Link>
							);
						}}
						content={() => reactPdfComp.current}
					/>
				</Button>
			</div>
			<ReactPdf.Document
				ref={reactPdfComp}
				loading={''}
				file={pdfFile}
				className={classes.documentPdf}
				onLoadSuccess={onDocumentLoadSuccess}>
				{renderAllPages()}
			</ReactPdf.Document>
		</ModalCustom>
	);
};

PdfViewer.propTypes = {
    downloadFileName: PropTypes.string,
	isOpenPdfViewer: PropTypes.bool.isRequired,
	onClose: PropTypes.func,
    pdfFile: PropTypes.string,
    title: PropTypes.string,
}

export default PdfViewer;